module.exports = __webpack_public_path__ + "img/baxtter.6ace1b47.png";